import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	searchPlaceHolder: {
		id: 'calendar.calendar-top-controls-bar.filters.search-place-holder',
		defaultMessage: 'Search calendar',
		description: 'Placeholder for search box',
	},
});
